import React, { useState, useRef } from 'react';
import { Container, Row, Col, Button, Badge, Dropdown } from 'react-bootstrap';
import { FaPlay, FaPause, FaVolumeUp, FaVolumeMute, FaArrowRight, FaCheck, FaUniversity } from 'react-icons/fa';
import './PromoSection.css';

// Importando as bandeiras
import ptFlag from '../../../assets/flag/flag-round-pt.png';
import enFlag from '../../../assets/flag/flag-round-ing.png';
import frFlag from '../../../assets/flag/flag-round-fr.png';

// Vídeos para cada idioma
const videos = {
  pt: {
    mp4: require('../../../assets/videos/Inscri_port.mp4'),
    poster: require('../../../assets/poster_ISPA.jpg'),
    flag: ptFlag
  },
  en: {
    mp4: require('../../../assets/videos/Inscri_Ing.mp4'),
    poster: require('../../../assets/poster_ISPA.jpg'),
    flag: enFlag
  },
  fr: {
    mp4: require('../../../assets/videos/Inscri_fr.mp4'),
    poster: require('../../../assets/poster_ISPA.jpg'),
    flag: frFlag
  }
};

// Conteúdo estático (não muda com o idioma)
const staticContent = {
  title: 'Transforme seu futuro no',
  description: 'Garanta sua vaga para o ano letivo 2025/2026 e dê o primeiro passo para uma carreira de sucesso com nossos cursos reconhecidos pelo mercado.',
  benefits: [
    'Infraestrutura moderna e laboratórios equipados',
    'Professores especialistas com experiência de mercado',
    'Programas de bolsa e financiamento estudantil',
    'Parcerias com empresas para estágios e empregos'
  ],
  badgeText: 'Inscrições Abertas 2025',
  enrollText: 'Inscreva-se Agora',
  coursesText: 'Conheça Nossos Cursos'
};

const PromoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [currentLanguage, setCurrentLanguage] = useState('pt');
  const [videoKey, setVideoKey] = useState(0);
  const videoRef = useRef(null);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play().catch(e => console.log("Auto-play prevented"));
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const changeLanguage = (lang) => {
    const wasPlaying = isPlaying;
    
    if (videoRef.current && wasPlaying) {
      videoRef.current.pause();
    }
    
    setCurrentLanguage(lang);
    setVideoKey(prevKey => prevKey + 1);
    
    if (wasPlaying) {
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.play().catch(e => console.log("Auto-play prevented after language change"));
        }
      }, 100);
    }
  };

  const currentVideo = videos[currentLanguage] || videos.pt;

  return (
    <section className="promo-section">
      <Container>
        <Row className="align-items-center">
          {/* Coluna do Vídeo */}
          <Col lg={6} className="video-col">
            <div className="video-wrapper">
              <video
                key={`video-${videoKey}`}
                ref={videoRef}
                loop
                muted={isMuted}
                poster={currentVideo.poster}
                className="promo-video"
              >
                <source src={currentVideo.mp4} type="video/mp4" />
                Seu navegador não suporta vídeos HTML5.
              </video>
              
              <div className="video-controls">
                <button onClick={togglePlay} className="control-btn" aria-label={isPlaying ? "Pausar vídeo" : "Reproduzir vídeo"}>
                  {isPlaying ? <FaPause /> : <FaPlay />}
                </button>
                <button onClick={toggleMute} className="control-btn" aria-label={isMuted ? "Ativar som" : "Desativar som"}>
                  {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
                </button>
                
                {/* Seletor de idiomas com bandeiras */}
                <Dropdown className="language-selector">
                  <Dropdown.Toggle variant="light" id="dropdown-language">
                    <img 
                      src={currentVideo.flag} 
                      alt={`${currentLanguage} flag`} 
                      className="language-flag"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => changeLanguage('pt')}>
                      <img src={ptFlag} alt="Português" className="language-flag me-2" />
                      Português
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => changeLanguage('en')}>
                      <img src={enFlag} alt="English" className="language-flag me-2" />
                      English
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => changeLanguage('fr')}>
                      <img src={frFlag} alt="Français" className="language-flag me-2" />
                      Français
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              
              <div className="play-overlay" onClick={togglePlay} style={{ display: isPlaying ? 'none' : 'flex' }}>
                <FaPlay className="play-icon" />
              </div>
            </div>
          </Col>

          {/* Coluna de Conteúdo (estático) */}
          <Col lg={6} className="content-col">
            <Badge pill bg="success" className="promo-badge mb-3">
              <FaUniversity className="me-2" /> 
              {staticContent.badgeText}
            </Badge>
            
            <h2 className="section-title">
              {staticContent.title} <span className="highlight">Instituto Atlântida</span>
            </h2>
            
            <p className="section-description">
              {staticContent.description}
            </p>
            
            <ul className="benefits-list">
              {staticContent.benefits.map((benefit, index) => (
                <li key={index}>
                  <FaCheck className="benefit-icon" />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
            
            <div className="cta-buttons">
              <Button variant="primary" size="lg" className="enroll-btn" href="https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura">
                {staticContent.enrollText} <FaArrowRight className="ms-2" />
              </Button>
              <Button style={{background:'#FFFFFF'}} size="lg" className="courses-btn" href="/programas/licenciatura">
                {staticContent.coursesText}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PromoSection;